const xDictionary = ["index",
"texas",
"extra",
"fixed",
"taxes",
"boxes",
"mixed",
"exist",
"exact",
"excel"]; export default xDictionary;